export default function getQueryParams(urlPath?: string): Record<string, string | null> {
    try {
        const queryParams: Record<string, string | null> = {};
        let search = "";

        if (urlPath) {
            const hasProtocol = urlPath.startsWith("http://") || urlPath.startsWith("https://");
            const fullUrl = hasProtocol ? urlPath : `https://fake.com${urlPath}`;
            search = new URL(fullUrl).search;
        } else {
            search = window.location.search;
        }

        if (!search) return {};
        const urlParams = new URLSearchParams(search);
        if ([...urlParams.keys()].length === 0) {
            return {};
        }
        [...urlParams.keys()].forEach((item: string) => {
            queryParams[item] = urlParams.get(item);
        });
        return queryParams;
    } catch (error) {
        console.log(error)
        return {};
    }
}
